import { 
  Box, 
  Button, 
  Chip, 
  CircularProgress, 
  IconButton, 
  Typography,
  Tooltip 
} from "@mui/material";
import { 
  Archive, 
  Delete, 
  Publish 
} from "@mui/icons-material";
import { useState } from "react";
import { truncateString } from "../../../../utils/truncate-string";
import { useNavigate } from "react-router-dom";
import PublishCollectionDialog from "./publish-collection-dialog";
import { Collection, CollectionStatus } from "../../../../models/collection";
import DeleteCollectionDialog from "./delete-collection-dialog";

interface CollectionCardProps {
  collection: Collection;
  // updateCollection: (collection: Collection) => void;
  onDelete: (collection_id: number) => void;
  runningTask: number;
}

export default function CollectionCard({ 
  collection, 
  // updateCollection, 
  onDelete,
  runningTask
}: CollectionCardProps) {
  const navigate = useNavigate();
  const [isPublishDialogOpen, setIsPublishDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  
  // const handleUpdateCollection = async () => {
  //   setIsLoading(true);
  //   try {
  //     await updateCollection(collection);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // const handleStatusToggle = (targetStatus: CollectionStatus) => {
  //   if (targetStatus === CollectionStatus.ARCHIVED) {
  //     collection.status = CollectionStatus.ARCHIVED;
  //     handleUpdateCollection();
  //   } else {
  //     if (collection.status === CollectionStatus.ARCHIVED) {
  //       collection.status = CollectionStatus.PUBLISHED;
  //       handleUpdateCollection();
  //     } else {
  //       setIsPublishDialogOpen(true);
  //     }
  //   }
  // };

  // const handlePublish = () => {
  //   setIsPublishDialogOpen(false);
  //   collection.status = CollectionStatus.PUBLISHED;
  //   handleUpdateCollection();
  // };

  const handleCardClick = () => {
    if (isDeleteDialogOpen || isPublishDialogOpen) return;
    navigate(`/classroom/${collection.classroom_id}/library/collections/${collection.id}`);
  };

  const getStatusChipProps = (status: CollectionStatus) => {
    switch (status) {
      case CollectionStatus.PUBLISHED:
        return {
          label: "Published",
          sx: {
            backgroundColor: '#e8f5e8',
            color: '#2e7d32',
            fontWeight: 500,
          }
        };
      case CollectionStatus.ARCHIVED:
        return {
          label: "Archived",
          sx: {
            backgroundColor: '#f5f5f5',
            color: '#616161',
            fontWeight: 500,
          }
        };
      default:
        return {
          label: "Draft",
          sx: {
            backgroundColor: '#f5f5f5',
            color: '#616161',
            fontWeight: 500,
          }
        };
    }
  };

  const isPublished = collection.status === CollectionStatus.PUBLISHED;
  const chipProps = getStatusChipProps(collection.status);

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: 80,
        backgroundColor: "white",
        border: 1,
        borderColor: isPublished ? 'success.main' : 'grey.300',
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          transform: 'translateY(-1px)',
          boxShadow: 2,
          borderColor: isPublished ? 'success.dark' : 'grey.400',
        },
      }}
      onClick={handleCardClick}            
    >
      {/* Header Section */}
      <Box sx={{ mb: 1 }}>
        <Typography 
          variant="subtitle1"
          sx={{
            fontWeight: 600,
            color: 'text.primary',
            lineHeight: 1.2,
          }}
        >
          {truncateString(collection.title, 30)}
        </Typography>
      </Box>

      {/* Footer Section */}
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        mt: 'auto'
      }}>
        <Chip
          {...chipProps}
          size="small"
          sx={{
            ...chipProps.sx,
            fontSize: '0.75rem',
            height: 24,
            textTransform: 'none',
          }}
        />

        <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
          {isLoading ? (
            <CircularProgress size={16} color="inherit" />
          ) : (
            <>
              {/* <Tooltip title={isPublished ? "Archive Collection" : "Publish Collection"}>
                <IconButton
                  onClick={(event) => {
                    event.stopPropagation();
                    handleStatusToggle(
                      isPublished ? CollectionStatus.ARCHIVED : CollectionStatus.PUBLISHED
                    );
                  }}
                  size="small"
                  sx={{
                    color: isPublished ? 'warning.main' : 'success.main',
                    backgroundColor: isPublished ? '#f5dcab' : '#d1fabb',
                    borderRadius: 2,
                    '&:hover': {
                      backgroundColor: isPublished ? 'warning.main' : 'success.main',
                      color: 'white',
                    },
                    transition: 'all 0.15s ease',
                  }}
                >
                  {isPublished ? (
                    <Archive sx={{ fontSize: 18 }} />
                  ) : (
                    <Publish sx={{ fontSize: 18 }} />
                  )}
                </IconButton>
              </Tooltip> */}

              {runningTask === collection.id ? (
                <CircularProgress size={18} />
              ) : (
                <Tooltip title="Delete Collection">
                  <IconButton
                    onClick={(event) => {
                      event.stopPropagation();
                      setIsDeleteDialogOpen(true);
                    }}
                    size="small"
                    sx={{
                      color: 'error.main',
                      backgroundColor: '#fccac5',
                      borderRadius: 2,
                      '&:hover': {
                        backgroundColor: 'error.main',
                        color: 'white',
                      },
                      transition: 'all 0.15s ease',
                    }}
                  >
                    <Delete sx={{ fontSize: 18 }} />
                  </IconButton>
                </Tooltip>
              )} 
            </>
          )}
        </Box>
      </Box>

      {/* Dialogs */}
      {/* <PublishCollectionDialog
        open={isPublishDialogOpen}
        setOpen={setIsPublishDialogOpen}
        updateCollectionDetails={handlePublish}
      /> */}

      <DeleteCollectionDialog
        open={isDeleteDialogOpen}
        setOpen={setIsDeleteDialogOpen}
        collection={collection}
        deleteFunction={onDelete}
      />
    </Box>
  );
}